import "./DropdownItemUI.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import React from "react";

interface IProps {
    text: string;
    icon: IconProp;
    disabled?: boolean;
}

export default function DropdownItemUI(props: IProps) {
    return (
        <div className={`dropdownItemUI ${props.disabled ? "disabledDropdownItemUI" : ""}`}>
            <div className="iconDiv">
                <FontAwesomeIcon icon={props.icon} className="iconDropdown" />
            </div>
            <div className="textDiv">{props.text}</div>
        </div>
    );
}
